import { useState } from 'react'

/**
 * Encapsulates the handle submit logic used on a number of forms in the application
 * as a custom hook that can be imported by functional components
 */
function useFormValidator() {
    const [valid, setValid] = useState(true)

    const handleSubmit = (
        event: React.FormEvent<HTMLFormElement>,
        success: VoidFunction
    ) => {
        event.preventDefault()
        const _valid = event.currentTarget.checkValidity()
        if (!_valid) {
            setValid(_valid)
            return
        }
        success()
    }

    const reset = () => {
        setValid(true)
    }

    return { valid, handleSubmit, reset }
}

export { useFormValidator }
